export const blogGrid = () => {
  var minColWidth = 500;
  var roots;

  function onLoad() {
    var rootElements = document.getElementsByClassName("masonry-root");
    roots = Array.prototype.map.call(rootElements, function (rootElement) {
      var cellElements = rootElement.getElementsByClassName("masonry-cell");
      var cells = Array.prototype.map.call(
        cellElements,
        function (cellElement) {
          var style = getComputedStyle(cellElement);
          return {
            element: cellElement,
            outerHeight:
              parseInt(style.marginTop) +
              cellElement.offsetHeight +
              parseInt(style.marginBottom),
          };
        }
      );
      return {
        element: rootElement,
        noOfColumns: 0,
        cells: cells,
      };
    });

    // do the first layout

    onResize();
  }

  function onResize() {
    for (let root of roots) {
      // only layout when the number of columns has changed
      // let wiw = (window.innerWidth - 230) / 3;

      let newNoOfColumns = 3;

      if (window.innerWidth > 1800) {
        //   wiw = (1920 - 448) / 3;
        newNoOfColumns = 3;
      }

      if (window.innerWidth < 1024) {
        //   wiw = (window.innerWidth - 140) / 2;
        newNoOfColumns = 2;
      }

      if (window.innerWidth < 577) {
        //   wiw = (window.innerWidth - 140) / 1;
        newNoOfColumns = 1;
      }

      //var newNoOfColumns = Math.floor(root.element.offsetWidth / wiw);
      //var newNoOfColumns = Math.floor(root.element.offsetWidth / minColWidth);

      if (newNoOfColumns != root.noOfColumns) {
        // initialize
        root.noOfColumns = newNoOfColumns;
        var columns = Array.from(new Array(root.noOfColumns)).map(function (
          column
        ) {
          return {
            cells: new Array(),
            outerHeight: 0,
          };
        });

        // divide...
        for (let cell of root.cells) {
          var minOuterHeight = Math.min(
            ...columns.map(function (column) {
              return column.outerHeight;
            })
          );

          
          var column = columns.find(function (column) {
            return column.outerHeight == minOuterHeight;
          });
          column.cells.push(cell);
          column.outerHeight += cell.outerHeight + 10;
        }

        // calculate masonry height
        var masonryHeight = Math.max(
          ...columns.map(function (column) {
            return column.outerHeight;
          })
        );

        // ...and conquer
        var order = 0;
        for (let column of columns) {
          for (let cell of column.cells) {
            cell.element.style.order = order++;
            //cell.element.style.flexBasis = order;
          }

          column.cells[column.cells.length - 1].element.style.flexBasis =
            column.cells[column.cells.length - 1].element.offsetHeight +
            masonryHeight -
            column.outerHeight -
            1 +
            "px";
        }

        // set the masonry height to trigger
        // re-rendering of all cells over columns
        // one pixel more than the tallest column
        root.element.style.maxHeight = masonryHeight + 10 + "px";

        // console.log(
        //   columns.map(function (column) {
        //     return column.outerHeight;
        //   })
        // );
      }
    }
  }

  window.addEventListener("load", onLoad);

  // subscribe to load and resize events
  // setInterval(function () {
  //   onResize();
  //   //onLoad();
  // }, 3000);

  window.addEventListener("resize", onLoad);

  Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
    console.log('all images loaded');
    onLoad();
  });
};
